import confetti from 'canvas-confetti'

let confettiFired = false
let confettiFrameRef = null
let confettiActive = false

export const stopConfetti = () => {
  confettiActive = false
  if (confettiFrameRef !== null) {
    cancelAnimationFrame(confettiFrameRef)
    confettiFrameRef = null
  }
  confetti.reset()
}

export const resetConfettiGuard = () => {
  confettiFired = false
}

/** @param {{ allowRepeat?: boolean }} options */
export const fireConfetti = ({ allowRepeat = false } = {}) => {
  if (confettiFired && !allowRepeat) return
  confettiFired = true
  confettiActive = true

  const duration = 3000
  const end = Date.now() + duration

  confetti({
    particleCount: 100,
    spread: 70,
    origin: { y: 0.6 },
    zIndex: 9999,
  })

  const frame = () => {
    if (!confettiActive) return

    confetti({
      particleCount: 3,
      angle: 60,
      spread: 55,
      origin: { x: 0 },
      zIndex: 9999,
    })
    confetti({
      particleCount: 3,
      angle: 120,
      spread: 55,
      origin: { x: 1 },
      zIndex: 9999,
    })

    if (Date.now() < end && confettiActive) {
      confettiFrameRef = requestAnimationFrame(frame)
    } else {
      confettiFrameRef = null
    }
  }

  confettiFrameRef = requestAnimationFrame(frame)
}
